// This file was automatically generated from render.signOff.html.
// Please don't edit this file by hand.

goog.provide('el8.template.render.signOff');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.signOff.summary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.signatures) {
    var signatureList32100 = opt_data.signatures;
    var signatureListLen32100 = signatureList32100.length;
    for (var signatureIndex32100 = 0; signatureIndex32100 < signatureListLen32100; signatureIndex32100++) {
      var signatureData32100 = signatureList32100[signatureIndex32100];
      output.append('<p class="el8SignoffText">');
      el8.template.render.signOff.summaryText({signUserName: signatureData32100.userName, signUserBehalfName: signatureData32100.onBehalfOfUserName, signDate: signatureData32100.signedAt, signComments: signatureData32100.signatureComments, signRole: signatureData32100.signatureRole, amendmentId: signatureData32100.amendmentId, feedItemId: opt_data.feedItemId, isImportedNote: opt_data.isImportedNote}, output);
      output.append('</p>');
    }
  } else {
    output.append('<p class="el8SignoffText">');
    el8.template.render.signOff.summaryText(opt_data, output);
    output.append('</p>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.signOff.feedSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FeedItemSmallLightText feed-summary-sign-section collapsible-section">');
  if (opt_data.signatures) {
    var signatureList32121 = opt_data.signatures;
    var signatureListLen32121 = signatureList32121.length;
    for (var signatureIndex32121 = 0; signatureIndex32121 < signatureListLen32121; signatureIndex32121++) {
      var signatureData32121 = signatureList32121[signatureIndex32121];
      el8.template.render.signOff.summaryText({signUserName: signatureData32121.userName, signUserBehalfName: signatureData32121.onBehalfOfUserName, signDate: signatureData32121.signedAt, signatureComments: signatureData32121.signatureComments, signRole: signatureData32121.signatureRole, amendmentId: signatureData32121.amendmentId, feedItemId: opt_data.feedItemId, isImportedNote: opt_data.isImportedNote}, output);
      output.append('<br/>');
    }
  } else {
    el8.template.render.signOff.summaryText(opt_data, output);
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.signOff.summaryText = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.signUserBehalfName) ? 'Signed off for ' + (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.signUserName)) : soy.$$escapeHtml(opt_data.signUserName)) + ' by ' + soy.$$escapeHtml(opt_data.signUserBehalfName) + ' on ' + (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.signDate)) : '') : (opt_data.signRole == 'amender') ? 'Amended and signed by ' + soy.$$escapeHtml(opt_data.signUserName) + ' on ' + (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.signDate)) : '') + ((! opt_data.isImportedNote) ? '<a class="edit-changes-trigger ml5" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '" _id="' + soy.$$escapeHtml(opt_data.amendmentId) + '">view changes</a>' : '') : ((opt_data.signUserType == 'OfficeStaff') ? 'Filed by' : (opt_data.signRole == 'cosigner') ? 'Co-signed by' : (opt_data.signRole == 'staff_autofiler') ? 'Auto-filed by' : 'Signed by') + ' ' + (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.signUserName)) : soy.$$escapeHtml(opt_data.signUserName)) + ' on ' + (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.signDate)) : ''), (opt_data.signatureComments) ? ': "' + soy.$$escapeHtml(opt_data.signatureComments) + '"' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.signOff.patientFormReviewSummaryText = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.signUserBehalfName) ? 'Reviewed by ' + soy.$$escapeHtml(opt_data.signUserBehalfName) + ' on ' + (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.signDate)) : '') : 'Signed by ' + (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.signUserName)) : soy.$$escapeHtml(opt_data.signUserName)) + ' on ' + (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.signDate)) : ''));
  if (!opt_sb) return output.toString();
};
